import { render, staticRenderFns } from "./ObjectsItem.vue?vue&type=template&id=fc11eb44&scoped=true"
import script from "./ObjectsItem.vue?vue&type=script&lang=js"
export * from "./ObjectsItem.vue?vue&type=script&lang=js"
import style0 from "./ObjectsItem.vue?vue&type=style&index=0&id=fc11eb44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc11eb44",
  null
  
)

export default component.exports